module.exports = __webpack_public_path__ + "img/setlogin.80fd240f.png";